import { BaseError } from "src/contexts/_shared/domain/errors/BaseError";

export class InvalidLinkTypeError extends BaseError {
  constructor(reason: string) {
    super(`Invalid link type error: ${reason}`);
  }
}
